import React from 'react';
import { InsuranceManagementEditTemplate } from 'themes/application/insurance-management/pages';
import { observer } from 'mobx-react';
import { InsuranceManagementEditViewStore } from 'application/insurance-management/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new InsuranceManagementEditViewStore(rootStore), 'insuranceManagementEditViewStore')
@observer
class InsuranceManagementEdit extends React.Component {
    render() {
        return <InsuranceManagementEditTemplate {...this.props} />
    }
}

export default InsuranceManagementEdit;
